import { render, staticRenderFns } from "./MyApprovals_Leave.vue?vue&type=template&id=1aa177ee&scoped=true"
import script from "./MyApprovals_Leave.vue?vue&type=script&lang=js"
export * from "./MyApprovals_Leave.vue?vue&type=script&lang=js"
import style0 from "./MyApprovals_Leave.vue?vue&type=style&index=0&id=1aa177ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa177ee",
  null
  
)

export default component.exports